module.exports = __webpack_public_path__ + "assets/juncal-alt.c3221fa3.svg";